module.exports = __webpack_public_path__ + "media/images/about-pointimg01-af893b927f2dd50d7a8c0615fbf8db3d.png";